var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuggestions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.711,
    height: 29.711,
    viewBox: "0 0 29.711 29.711",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_twotone_sms",
    "data-name": "vuesax/twotone/sms",
    transform: "translate(-556 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sms",
    transform: "translate(556 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.569,21.045H6.19c-3.714,0-6.19-1.857-6.19-6.19V6.19C0,1.857,2.476,0,6.19,0h12.38c3.714,0,6.19,1.857,6.19,6.19v8.666C24.759,19.188,22.283,21.045,18.569,21.045Z",
    transform: "translate(2.476 4.333)",
    fill: "none",
    stroke: "#fff595",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M12.38,0,8.5,3.095a3.919,3.919,0,0,1-4.642,0L0,0",
    transform: "translate(8.666 11.142)",
    fill: "none",
    stroke: "#fff595",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H29.711V29.711H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestions);
export default __webpack_public_path__ + "static/media/suggestions.98e950c4ec720429029a4ffcfe9bb8df.svg";
export { ForwardRef as ReactComponent };